import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'heightFormat'
})
export class HeightFormatPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): string {
    const parsedValue = this.parse(+value);

    const finalValues = [];
    if (parsedValue.feet) {
      finalValues.push(`${parsedValue.feet}'`);
    }
    if (parsedValue.inches) {
      if(parsedValue.feet) {
        finalValues.push(' ');
      }
      finalValues.push(`${parsedValue.inches}`);
      if (parsedValue.cm) {
        finalValues.push('-');
        finalValues.push(this.formatCm(parsedValue.cm));
      }
      finalValues.push('"');
    } else {
      if (parsedValue.cm) {
        if(parsedValue.feet) {
          finalValues.push(' ');
        }
        finalValues.push(this.formatCm(parsedValue.cm));
        finalValues.push('"');
      }
    }

    return finalValues.join('');
  }

  formatCm(cm) {
    switch (cm) {
      case 1: return `1/8`;
      case 2: return `1/4`;
      case 3: return `3/8`;
      case 4: return `1/2`;
      case 5: return `5/8`;
      case 6: return `3/4`;
      case 7: return `7/8`;
    }
    return '';
  }

  parse(value: number) {
    const feet = Math.trunc(value / 12);
    const inches = Math.trunc((value % 12));
    const cm = Math.round(((value % 12) - inches) * 8);
    return {
      feet,
      inches,
      cm,
    }
  }

}
